import type { AssetGroup } from '@/entities/account';

export const BASE_ASSETS = {
  USDT: 'USDT',
  USD: 'USD',
  RUB: 'RUB',
  BYN: 'BYN',
  EUR: 'EUR',
} as const;

export type BaseAsset = keyof typeof BASE_ASSETS;

export type AssetsPriceAsset = {
  code: string;
  name: string;
  precision: number;
  group: AssetGroup;
  cmCapRank: number;
  baseRate: number;
  baseRateNoMarkup: number;
  percentChange1h: number;
  percentChange24h: number;
  percentChange7d: number;
  percentChange30d: number;
  isShowInPrices: 0 | 1;
  [key: string]: unknown;
};

export type AssetPricesResponse = {
  autoRefreshAssetsPricesTime: number;
  baseCode: string;
  baseName: string;
  basePrecission: number;
  assets: AssetsPriceAsset[];
};

export type AssetsAsset = {
  code: string;
  group: AssetGroup;
  name: string;
  precision: number;
};

export type AuthorizedTradingUrlResponse = {
  tradingUrl: string;
};

export const ASSET_PRICES_FILTER = {
  all: 'all',
  hot: 'hotassets',
  new: 'newassets',
  gainers: 'gainersassets',
  losers: 'losersassets',
} as const;

export type AssetPricesFilter =
  (typeof ASSET_PRICES_FILTER)[keyof typeof ASSET_PRICES_FILTER];

export type QuoteHistoryPeriod = '1d' | '1w' | '1m' | '1y';

export type QuoteHistoryAxisLabel = {
  showValue: string;
  axisPoint: number;
};

export type QuoteHistoryPoint = {
  timestamp: number;
  price: number;
};

export type QuoteHistoryResponse = {
  from: number;
  to: number;
  symbol: string;
  axesLabels: {
    time: QuoteHistoryAxisLabel[];
    price: QuoteHistoryAxisLabel[];
  };
  points: QuoteHistoryPoint[];
};
